module.exports = __webpack_public_path__ + "static/media/hotbed-starboard-7:17:2021.3ab1d19e.png";